import { render } from "./Library.vue?vue&type=template&id=a98cc7a4&scoped=true"
import script from "./Library.vue?vue&type=script&lang=ts"
export * from "./Library.vue?vue&type=script&lang=ts"

import "./Library.vue?vue&type=style&index=0&id=a98cc7a4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a98cc7a4"

export default script